var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.9686V5C9 3.34315 10.3432 2 12 2C13.6568 2 15 3.34315 15 5V6.00285",
    stroke: "#1F2124",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.0017V19C15 20.6568 13.6568 22 12 22C10.3432 22 9 20.6568 9 19V17.985",
    stroke: "#1F2124",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H4.99207C3.33959 15 2 13.6568 2 12C2 10.3432 3.33959 9 4.99207 9H5.9943",
    stroke: "#1F2124",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9H18.9944C20.6544 9 22 10.3432 22 12C22 13.6568 20.6544 15 18.9944 15H18.0331",
    stroke: "#1F2124",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocials);
export default __webpack_public_path__ + "static/media/socials.30ac1516a489edd80b1b9e5d395a61db.svg";
export { ForwardRef as ReactComponent };